module.exports = __webpack_public_path__ + "assets/img/351a58849f016ece6ee4dd65a1ed8735.png";